(function () {

  'use strict';

  angular.module('eclipseApp.myAccount').controller('accountDetailsModalCtrl', ['$scope', '$rootScope', '$modalInstance', 'commonService', '$stateParams', 'uteLocale', 'data', '$state', 'prepaidUserInfoService','$sessionStorage', function ($scope, $rootScope, $modalInstance, commonService, $stateParams, uteLocale, data, $state, prepaidUserInfoService, $sessionStorage) {

    console.log('accountDetailsModalCtrl');
    var paperBillingList = [] ;
    var paymentMethodList = [] ;
    var usageList = [];
    var firstSubscriberNo = [];
    var firstSubscriberNo='';
    $scope.$storage = $sessionStorage;

    if (data.sectionName  === 'billingSection') {
      _.each(commonService.accountDetails, function (accountDetail) {
         if ((accountDetail.billingType) && (accountDetail.LOB) && (accountDetail.billingType.toLowerCase() ==='paper') && (accountDetail.LOB.toLowerCase() !== 'wlpp')) {
           paperBillingList.push(accountDetail);
         }
       });
       $scope.accountDetails = paperBillingList ;

    } else if (data.flowName === 'paymentMethod') {
      _.each(commonService.accountDetails, function (accountDetail) {
         if ((accountDetail.LOB) && (accountDetail.LOB.toLowerCase() !== 'wlpp')) {
           paymentMethodList.push(accountDetail);
         }
       });
       $scope.accountDetails = paymentMethodList ;

    }
    else if (data.flowName ==='viewUsage'){
      _.each(commonService.accountDetails, function (accountDetail) {
        if (!(_.isEmpty(accountDetail.subscriberServices))  && accountDetail.accountStatus
          && accountDetail.accountStatus.toUpperCase() !== 'CANCELLED' && accountDetail.accountStatus.toUpperCase() !== 'SUSPENDED') {
          usageList.push(accountDetail);
        }
      });
      $scope.accountDetails = usageList ;
      console.log("usageList",usageList);
    }
    else {
      $scope.accountDetails = commonService.accountDetails;
    }

    $scope.firstSubscriberNoFinder= function (accType, accNum){
      var selectedAccountDetail,subscriberCTN;

      console.log('$scope.selectedAccountNumber', accNum);

      if (accNum) {
        selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
            return accountDetail.accountNumber === accNum;
        });
        console.log('selectedAccountDetail', selectedAccountDetail);
      }
      if ((selectedAccountDetail.LOB) && (selectedAccountDetail.LOB === accType)) {
        if ((!(_.isEmpty(selectedAccountDetail.subscriberServices)))) {
          for (var i = 0; i < selectedAccountDetail.subscriberServices.length; i++) {
            if ((selectedAccountDetail.subscriberServices[i].wireless != null && selectedAccountDetail.subscriberServices[i].wireless.subscriberNo != null) || (selectedAccountDetail.subscriberServices[i].internet != null && selectedAccountDetail.subscriberServices[i].internet.subscriberNo != null)) {
              if (accType==='WL' || accType === 'WLPP'){
                firstSubscriberNo = selectedAccountDetail.subscriberServices[i].wireless.subscriberNo;
                if(selectedAccountDetail.LOB === 'WLPP'){
                  prepaidUserInfoService.setBAN(selectedAccountDetail.accountNumber);
                  $scope.$storage.selectedBAN = selectedAccountDetail.accountNumber;
                  prepaidUserInfoService.setCTN(firstSubscriberNo);
                  $scope.$storage.selectedCTN = firstSubscriberNo;
                }
                break;
              }
              else {
                firstSubscriberNo = selectedAccountDetail.subscriberServices[i].internet.subscriberNo;
                break;
              }
            }
          }
        }
      }

      /*_.each(commonService.accountDetails, function (accountDetail) {
        console.log("account in modal"+accountDetail.subscriberServices[0])
         if ((accountDetail.LOB) && (accountDetail.LOB === accType) && (accountDetail.LOB.toLowerCase() !== 'wlpp')) {
          if(accType==='WL'){
            firstSubscriberNo = accountDetail.subscriberServices[0].wireless.subscriberNo;
          }
          else {
              firstSubscriberNo= accountDetail.subscriberServices[0].internet.subscriberNo;
            };
         }
      });*/
    }

    $scope.accountPref = function(accNum,accType){
      $scope.firstSubscriberNoFinder(accType,accNum);
      var stateVariable = 'myAccount.'+ data.flowName;
       if (data.flowName=='viewUsage'){
           if(accType==='WL'){
              stateVariable = 'myAccount.wireless';
           }else if(accType==='WLPP'){
              stateVariable = 'myAccount.prepaidWLDashboard';
           }else {
              stateVariable = 'myAccount.internetUsage.daily';
           }
           $state.go( stateVariable, {'accountNumber': accNum,'subscriberNo': firstSubscriberNo  });
       }else if(accType==='WLPP' && data.flowName == 'payNow'){
           stateVariable = 'myAccount.'+'prepaidRefill';
           $state.go(stateVariable, {'accountNumber': accNum , 'subscriberNo': firstSubscriberNo, 'sectionName': data.sectionName });
       }else if(accType==='WLPP' && data.flowName == 'viewInvoice') {
           stateVariable = 'myAccount.' + 'viewTransactionHistory';
           $state.go(stateVariable, {'accountNumber': accNum,'subscriberNo': firstSubscriberNo,'sectionName': data.sectionName});
       }else{
           $state.go(stateVariable, {'accountNumber': accNum , 'sectionName': data.sectionName, 'action': data.action });
       }
    }
  }]);

})();
